export default __webpack_public_path__ + "static/media/SZ07.64b6982d.mp3";